import React, { ReactElement } from 'react';
import {
	FormField,
	DragDropText,
	UploadFileBtn
} from '../EncryptWrapper.styles';
import PDFImage from '../../../assets/pdf.svg';
const defaultProps = {};
type PdfUploaderProps = {
	handleUploadButtonClick: () => void;
	onChange: (e: any) => void;
	fileInputRef: any;
} & typeof defaultProps;

export const PdfUploader = ({
	handleUploadButtonClick,
	onChange,
	fileInputRef
}: PdfUploaderProps): ReactElement => {
	return (
		<>
			<img
				alt='images icon'
				height={75}
				src={PDFImage}
				style={{ margin: '15px' }}
			/>

			<UploadFileBtn type='button' onClick={handleUploadButtonClick}>
				<i className='fas fa-file-upload' />
				<span>PDF</span>
			</UploadFileBtn>
			<DragDropText>Or Drag and drop your PDF here</DragDropText>
			<FormField
				type='file'
				ref={fileInputRef}
				onChange={onChange}
				title=''
				value=''
				// {...otherProps}
				accept='application/pdf'
			/>
		</>
	);
};
PdfUploader.defaultProps = defaultProps;
